import { BreadcrumbLoader } from "../../../../decorators/BreadcrumbLoader";
import { BreadcrumbNameLoader } from "../../../../services/breadcrumbs/breadcrumbLoaders/breadcrumbNameLoaders/BreadcrumbNameLoader";
import { texts } from "../../../../i18n/texts";

@BreadcrumbLoader("/license-log")
export class AdminViewLicenseLogBreadcrumbNameLoader extends BreadcrumbNameLoader {
  name = texts.adminView.licenseLog;
}
